angular.module("digitalLeasing.module")
    .component("preleasingExpensesDuplicaAutorizza", {
        templateUrl: "ng/components/digitalLeasing/financialData/preleasingExpensesDuplicaAutorizza/preleasingExpensesDuplicaAutorizza.view.html",
        bindings: {
            model: "=",
            onPreleasingExpensesChange: "&",
            prelocationRate: "<",
            tassi: "<",
            snapshot:'<'
        },
        controllerAs: "preleasingExpensesDuplicaAutorizzaCtrl",
        controller: PreleasingExpensesDuplicaAutorizzaController
    });

function PreleasingExpensesDuplicaAutorizzaController(
    $q,
    $financialApiService,
    $rootScope
) {

    var self = this;
    self.$rootScope = $rootScope; 

    self.$onInit = function () {
        console.log(self.model);
        self.supportModel = {
            tassi: [],
            valueTassi: {}
        }

        if (!self.snapshot) {
            indiciPrelocazione()
            .then(function (list) {
                self.supportModel.tassi = list;
            });
        }

        if (self.model.tassiCalcolati.tassoPrelocazione.id) {
            self.supportModel.valueTassi = self.model.tassiCalcolati.tassoPrelocazione;
        }
    }

    self.$onChanges = function (changes) {

        if (changes.prelocationRate && changes.prelocationRate.currentValue && self.supportModel.tassi.length > 0) {
            self.model.tassiCalcolati.tassoPrelocazione.spreadPrelocazione = changes.prelocationRate.currentValue.spreadPrelocazione;
            self.supportModel.valueTassi = self.supportModel.tassi
                .find(function (e) {
                    return e.id == changes.prelocationRate.currentValue.id
                })
            self.handlePreleasingChange('prelocazione', self.supportModel.valueTassi)
        }

    }

    self.handlePreleasingChange = function (type, value) {
        switch (type) {
            case 'prelocazione':
                self.model.tassiCalcolati.tassoPrelocazione.id = value.id;
                self.model.tassiCalcolati.tassoPrelocazione.description = value.description;
                break;

            case 'spreadPrelacazione':
                console.log(value);
                break;

            default:
                break;
        }
    }


    var indiciPrelocazione = function () {

        return $q(function (resolve, reject) {
            $financialApiService.indiciPrelocazione()
                .then(function (response) {
                    resolve(response)
                })
                .catch(function (error) {
                    reject(error) 
                })
        })
    }
}